import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from 'src/app/core/jsonapi/service';
import { DataImport } from '../_types/data-import';

@Injectable({ providedIn: 'root' })
export class DataImportsService extends Service<DataImport> {
    public override type = 'dataImports';
    public override url = 'common/dataImports';

    validate(request: { fileId: string; importType: number; mode: string; stopOnFirstError: boolean; dryRun: boolean; allowDuplicates: boolean; truncateValues: boolean }): Observable<any> {
        return this.http.post<any>(this.getAPIUrl() + '/validate', request);
    }

    promote(id: string): Observable<any> {
        return this.http.post<any>(`${this.getAPIUrl()}/${id}/promote`, {});
    }
}
